export default {
  state: {
    modelReady: false,
    unitsShown: true,
    keyplateImg: '',
    keyplateShown: false,
    lastSelectedUnits: [],
    lastFilteredUnits: [],
    lastAction: ''
  },
  getters: {
    getModelReady: state => state.modelReady,
    getUnitsShown: state => state.unitsShown,
    getKeyplateImg: state => state.keyplateImg,
    getKeyplateShown: state => state.keyplateShown,
    getLastAction: state => state.lastAction,
    getLastSelectedUnits: state => state.lastSelectedUnits,
    getLastFilteredUnits: state => state.lastFilteredUnits
  },
  actions: {
    SET_UNITS_SHOWN({ commit, dispatch, getters }, data) {
      if (!getters.getModelReady) {
        return;
      }
      commit('setUnitsShown', data.enabled);
      if (data.enabled) {
        dispatch('REAPPLY_LAST_ACTION', data.curRoute);
      } else {
        dispatch('CLEAR_UNITS');
      }
    },
    REAPPLY_LAST_ACTION({ dispatch, getters }, curRoute) {
      if (!getters.getModelReady) {
        return;
      }

      try {
        dispatch('CLEAR_UNITS');
        if (curRoute === 'FloorplanDetail') {
          window.frames.model.pc.app.fire('selectUnits', getters.getLastSelectedUnits);
        } else if (curRoute === 'FloorplanList') {
          if (getters.getLastFilteredUnits.length === 0) {
            window.frames.model.pc.app.fire('filterUnits', getters.activeUnits);
          } else {
            window.frames.model.pc.app.fire('filterUnits', getters.getLastFilteredUnits);
          }
        }
      } catch (e) {
        console.warn('error restoring units shown', e);
      }
    },
    SET_KEYPLATE({ commit }, keyplateURL) {
      commit('setKeyplate', keyplateURL);
    },
    SELECT_PLAN({ commit, dispatch, getters }, plan) {
      if (!getters.getModelReady) {
        return;
      }
      try {
        const selectedUnits = [];
        plan.stacks.forEach((stack) => {
          stack.suites.forEach((suite) => {
            const pcUnit = suite.name;
            if (suite.status === 'available') {
              selectedUnits.push(pcUnit);
            }
          });
        });

        if (getters.getUnitsShown) {
          window.frames.model.pc.app.fire('selectUnits', selectedUnits);
          // TODO. We need to create a function that modifies the distance according to the viewable height(ipad size vs desktop etc) for each project
          dispatch('SET_DIR', { dir: plan.exposure.join(''), distance: 150 });
        }
        commit('setLastSelected', selectedUnits);
      } catch (e) {
        console.warn('error selecting units', e);
      }
    },
    // dir = 'n' or 'e' etc. actual angles are defined within playcanvas.
    SET_DIR({ getters }, data) {
      if (!getters.getModelReady) {
        return;
      }
      try {
        window.frames.model.pc.app.fire('setDirection', data.dir, data.distance);
      } catch (e) {
        console.warn('error setting direction', e);
      }
    },
    RESET_VIEW({ getters }) {
      if (!getters.getModelReady) {
        return;
      }
      window.frames.model.pc.app.fire('resetView');
    },
    FILTER_UNITS({ commit, dispatch, getters }, units) {
      try {
        if (getters.getUnitsShown) {
          dispatch('CLEAR_UNITS');
          window.frames.model.pc.app.fire('filterUnits', units);
        }
        commit('setLastFiltered', units);
      } catch (e) {
        console.warn('error filtering units', e, units);
      }
    },
    CLEAR_UNITS({ getters }) {
      if (!getters.getModelReady) {
        return;
      }
      try {
        window.frames.model.pc.app.fire('clearUnits');
      } catch (e) {
        console.warn('error clearing units', e);
      }
    },
    TOGGLE_KEYPLATE_SHOWN({ commit }, onOff) {
      commit('setKeyplateShown', onOff);
    },
    SET_MODEL_READY({ commit }) {
      commit('setModelReady');
    }
  },
  mutations: {
    setUnitsShown(state, enabled) {
      state.unitsShown = enabled;
    },
    setKeyplate(state, keyplateURL) {
      state.keyplateImg = keyplateURL;
    },
    setKeyplateShown(state, onOff) {
      state.keyplateShown = onOff;
    },
    setLastSelected(state, units) {
      state.lastSelectedUnits = units;
      state.lastAction = 'select';
    },
    setLastFiltered(state, units) {
      state.lastFilteredUnits = units;
      state.lastAction = 'filter';
    },
    setModelReady(state) {
      state.modelReady = true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/Model.js